import StepCalendly from './steps/StepCalendly';
import StepFinish from './steps/StepFinish';
import StepTimeSelector from './steps/StepTimeSelector';

type StepComponentType = React.FC<any>;

export const stepsConfig: { key: string; component: StepComponentType }[] = [
  { key: 'time', component: StepTimeSelector },
  { key: 'calendly', component: StepCalendly },
  { key: 'finish', component: StepFinish },
];
